import { render } from "./ClientsStats.vue?vue&type=template&id=2a5ed116&scoped=true"
import script from "./ClientsStats.vue?vue&type=script&lang=js"
export * from "./ClientsStats.vue?vue&type=script&lang=js"

import "./ClientsStats.vue?vue&type=style&index=0&id=2a5ed116&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5ed116"]])

export default __exports__